/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'result': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M65.09 127.585v768.83h893.82v-768.83H65.09zm843.037 717.072H115.906V189.608h792.22v655.05z"/><path pid="1" d="M301.137 430.197H199.585v-99.1h101.552v99.1zM834.21 392.176H334.88v-20.4h499.33v20.4zM301.137 586.11H199.585v-99.1h101.552v99.1zM834.21 547.983H334.88v-20.274h499.33v20.274zM301.137 742.002H199.585V642.86h101.552v99.142zM834.21 703.895H334.88v-20.314h499.33v20.314z"/>'
  }
})
